import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxEvent } from '../../../assets/pagedata/constant';
import { checkForTaxSeason } from '../Util/CommonUtils';
import { FreeShippingPromo } from './FreeShippingPromo';
import TaxSeasonPromo from './TaxSeasonPromo';

const PromoBanner = (props) => {
  const dispatch = useDispatch();
  const [promoBanner, setPromoBanner] = useState('FSH');

  const mainReducer = useSelector((state) => state.mainReducer);

  const promoBannerTaxSeason = () => {
    if (mainReducer.isTaxSeason) {
      setPromoBanner('TAX_SEASON');
    } else {
      // load other banner as per priority
    }
  };

  const promoBannerFsh = (isActive) => {
    if (isActive) {
      setPromoBanner('FSH');
    } else {
      const isTaxSeason = checkForTaxSeason(mainReducer.systemDate);
      if (isTaxSeason) {
        dispatch({ type: ReduxEvent.TAX_SEASON, data: { isTaxSeason: { isTaxSeason } } });
        promoBannerTaxSeason();
      }
    }
  };

  const fshPromoAttr = {
    isPromoActive: promoBannerFsh,
  };

  switch (props.page) {
    case 'ALL_CHECKS':
      fshPromoAttr.chekoutBanner = true;
      break;
    case 'HOME':
    case 'INPRODUCTLANDING':
      fshPromoAttr.chekoutBanner = true;
      fshPromoAttr.homePage = true;
      break;
    default:
      break;
  }

  switch (promoBanner) {
    case 'TAX_SEASON':
      return <TaxSeasonPromo {...props} />;
    case 'FSH':
    default:
      return <FreeShippingPromo {...fshPromoAttr} />;
  }
};

PromoBanner.propTypes = {
  page: PropTypes.string,
};

export default PromoBanner;
